<template>
  <div>
    <ocpc type="ocpcList" />
  </div>
</template>
<script>
import Ocpc from './components/OcpcMain'
export default {
  components: {
    Ocpc
  }
}
</script>
